import React from "react";
import { Navbar } from "./index";
import "animate.css";
export default function Banner({
  Scrolltoref,
  scrolltoWorks,
  scrolltoAbout,
  scrolltoContact,
}) {
  return (
    <>
      <div className="background_image  w-screen h-[85vh] md:h-[100vh]">
        <Navbar
          Scrolltoref={Scrolltoref}
          scrolltoWorks={scrolltoWorks}
          scrolltoAbout={scrolltoAbout}
          scrolltoContact={scrolltoContact}
        />
        <div className=" space-y-7 z-50 md:space-y-10 my-24 mx-6 md:my-0 md:mx-0 md:absolute md:top-[45%] md:left-[8%] md:transform md:-translate-x-[8%] md:-translate-y-[40%]">
          <h1 className="text-red-500 md:text-lg animate__animated animate__slideInLeft animate__slow">
            Elevate. Innovate. SaaSify.
          </h1>
          <div className="animate__animated animate__slideInLeft animate__slow">
            <h1 className="text-5xl font-bold text-white md:text-8xl">
              We are Digital
            </h1>
            <h1 className="text-5xl font-bold text-white md:text-8xl">
              Agency
            </h1>
          </div>
          <button
            onClick={scrolltoContact}
            className="px-8 py-4 font-semibold text-white duration-500 ease-in-out border-2 border-red-500 animate__animated animate__slideInLeft animate__slow hover:bg-white hover:text-black hover:border-white md:text-lg"
          >
            Get Started
          </button>
        </div>
      </div>
    </>
  );
}
